import request from '../api/request'
import businessHelper from "../helpers/BusinessHelper";
import dateHelpers from "../helpers/DateHelper";

function login(e, p, locale, isClientLogin = false) {
    return request({
        url: `auth/login.json`,
        method: 'POST',
        data: {
            email: e,
            password: p,
            timestamp: dateHelpers.databaseDateTime(new Date()),
            locale: locale,
            is_client_login: false
        }
    });
}

function register(data) {
    return request({
        url: `signup.json`,
        method: 'POST',
        data: data
    });
}

function current() {
    return request({
        url: `users/current.json`,
        method: 'GET',
    });
}

function update(data) {
    return request({
        url: `users/update_current.json`,
        method: 'POST',
        data: data
    });
}

function updateLocale(data) {
    return request({
        url: `users/-1/update_locale.json`,
        method: 'PUT',
        data: data
    });
}

function publicProfile() {
    return request({
        url: `businesses/-4/public_profile.json`,
        method: 'GET',
    });
}

function updateTermsLink(link) {
    return request({
        url: `businesses/update_terms_link?terms_link=${link}.json`,
        method: 'POST',
    });
}

function getBusiness(id) {
    return request({
        url: `businesses/${id}.json`,
        method: 'GET',
    });
}

function getBusinesses() {
    return request({
        url: `businesses.json`,
        method: 'GET',
    });
}

function updateReqFields(fields) {
    return request({
        url: `businesses/update_req_fields.json`,
        method: 'POST',
        data: fields
    });
}

function profile() {
    return request({
        url: `users/${businessHelper.business().id}/user_profile.json`,
        method: 'GET',
    });
}

function updateSM(data) {
    return request({
        url: `users/-4/update_social_media.json`,
        method: 'POST',
        data: data
    });
}

function postAd(data) {
    return request({
        url: `businesses/post_ad.json`,
        method: 'POST',
        data: data
    });
}

function updateAd(data) {
    return request({
        url: `businesses/update_ad.json`,
        method: 'POST',
        data: data
    });
}

function deleteAd(id) {
    return request({
        url: `businesses/delete_ad.json?id=${id}`,
        method: 'POST',
    });
}

function getTeam() {
    return request({
        url: `users/team.json`,
        method: 'GET',
    });
}

function deleteMember(data) {
    return request({
        url: `users/delete_member.json`,
        method: 'POST',
        data: data
    });
}

function updateMember(member, locale) {
    return request({
        url: `users/update_member.json?member_id=${member.id}&locale_id=${locale.id}`,
        method: 'PUT',
    });
}

function addMember(data) {
    return request({
        url: `users/add_member.json`,
        method: 'POST',
        data: data
    });
}

function notifications() {
    return request({
        url: `users/notifications.json`,
        method: 'GET',
    });
}

function rewards() {
    return request({
        url: `rewards.json`,
        method: 'GET',
    });
}

function forgot(email) {
    return request({
        url: `password/forgot.json`,
        method: 'POST',
        data: {email: email}
    });
}

function reset(data) {
    return request({
        url: `password/reset.json`,
        method: 'POST',
        data: data
    });
}

function createSubscription(data) {
    return request({
        url: `subscriptions/create_subscription.json`,
        method: 'POST',
        data: data
    });
}

function createMembershipSubscription(data) {
    return request({
        url: `subscriptions/create_membership_subscription.json`,
        method: 'POST',
        data: data
    });
}

function registerSubscription(data) {
    return request({
        url: `subscriptions/register_subscription.json`,
        method: 'POST',
        data: data
    });
}

function cancelSubscription() {
    return request({
        url: `subscriptions/cancel.json`,
        method: 'POST',
    });
}

function enableFreeTrial() {
    return request({
        url: 'users/free_trial.json',
        method: 'POST'
    })
}

function sendSupportMessage(data) {
    return request({
        url: `businesses/support_message.json`,
        method: 'POST',
        data: data
    });
}

function verify(data) {
    return request({
        url: `users/verify.json`,
        method: 'POST',
        data: data
    });
}

function deleteRank(id) {
    return request({
        url: `student_ranks/${id}.json`,
        method: 'DELETE'
    });
}

function deleteReward(id) {
    return request({
        url: `rewards/${id}.json`,
        method: 'DELETE'
    });
}

function assign_rank_to_student(rankId, studentId) {
    return request({
        url: `student_ranks/assign_to_student.json`,
        method: 'POST',
        data: {rank_id: rankId, student_id: studentId}
    });
}

function assignRewardToStudent(rewardId, studentId) {
    return request({
        url: `rewards/assign_to_student.json`,
        method: 'POST',
        data: {reward_id: rewardId, student_id: studentId}
    });
}

function unassignRewardFromStudent(rewardId, studentId) {
    return request({
        url: `rewards/unassign_from_student.json`,
        method: 'POST',
        data: {reward_id: rewardId, student_id: studentId}
    });
}

function unassign_rank_from_student(rankId, studentId) {
    return request({
        url: `student_ranks/unassign_from_student.json`,
        method: 'POST',
        data: {rank_id: rankId, student_id: studentId}
    });
}

function createRank(data) {
    return request({
        url: `student_ranks.json`,
        method: 'POST',
        data: data
    });
}

function updateRank(data) {
    return request({
        url: `student_ranks/${data.id}.json`,
        method: 'PUT',
        data: data
    });
}

function updateReward(data) {
    return request({
        url: `rewards/${data.id}.json`,
        method: 'PUT',
        data: data
    });
}

function createReward(data) {
    return request({
        url: `rewards.json`,
        method: 'POST',
        data: data
    });
}

function sendMessage(groupId, data) {
    return request({
        url: `student_ranks/send_message.json?id=${groupId}`,
        method: 'POST',
        data: data
    });
}

function sendMessageToAll(params) {
    return request({
        url: `businesses/message_all.json`,
        method: 'POST',
        data: params
    });
}

function businessMessages() {
    return request({
        url: `open_messages.json`,
        method: 'GET',
    });
}

function studentMessages(studentId) {
    return request({
        url: `open_messages/student_messages.json?id=${studentId}`,
        method: 'GET',
    });
}

function sendStudentMessage(studentId, message) {
    return request({
        url: `open_messages/send_message_to_student.json`,
        method: 'POST',
        params: {id: studentId, message: message}
    });
}

function sendAppInviteMessage(params) {
    return request({
        url: `businesses/send_app_invite.json`,
        method: 'POST',
        data: params
    });
}

function create_invoice(i) {
    return request({
        url: `invoices_api/create_invoice.json`,
        method: 'POST',
        data: i
    });
}

function update_invoice(i) {
    return request({
        url: `invoices_api/update_invoice.json`,
        method: 'POST',
        data: i
    });
}

function updateWelcomeEmailPrefs(checked, settingId) {
    return request({
        url: `users/update_welcome_state.json?enabled=${checked}&id=${settingId}`,
        method: 'POST',
    });
}

function updateWelcomeCustomText(text, settingId) {
    return request({
        url: `users/welcome_message_txt.json?custom_message=${text}&id=${settingId}`,
        method: 'POST',
    });
}

function updateExpTicketEmailPrefs(checked, settingsId) {
    return request({
        url: `users/update_exp_ticket_state.json?enabled=${checked}&id=${settingsId}`,
        method: 'POST',
    });
}

function checkCouponCode(code) {
    return request({
        url: `subscriptions/check_ccode.json?ccode=${code}`,
        method: 'POST'
    });
}

function connectStripe(code) {
    return request({
        url: `businesses/connect_to_s.json?code=${code}`,
        method: 'POST'
    });
}

function disconnectStripe() {
    return request({
        url: `users/disconnect_stripe.json`,
        method: 'POST'
    });
}

function sendVerificationEmail() {
    return request({
        url: `businesses/verify_email.json`,
        method: 'POST'
    });
}

function weekEvents(business_id, weekStart, studentId) {
    return request({
        url: `businesses/${business_id}/week_classes.json?week_start=${weekStart}&student_id=${studentId}`,
        method: 'GET'
    });
}

function updateAddress(params) {
    return request({
        url: `users/update_user_address.json`,
        method: 'POST',
        params: params
    });
}

function createPaymentIntent(params) {
    return request({
        url: `products/capture_payment.json`,
        method: 'POST',
        params: params
    });
}

function createPaymentSession(priceId) {
    return request({
        url: `products/business_payment_session.json`,
        method: 'POST',
        data: {
            price_id: priceId,
        }
    });
}

function getMessageSettings() {
    return request({
        url: `businesses/message_settings.json`,
        method: 'GET',
    });
}

function saveBdSettings(data) {
    return request({
        url: `businesses/save_bd_settings.json`,
        method: 'POST',
        params: data
    });
}

function saveClassReminderSettings(data) {
    return request({
        url: `businesses/update_y_reminder_state.json`,
        method: 'POST',
        params: data
    });
}

function setMaster(master_id) {
    return request({
        url: `users/set_master.json?id=${master_id}`,
        method: 'POST',
    });
}

function saveClassRegistrationSettings(data) {
    return request({
        url: `businesses/update_y_registration_state.json`,
        method: 'POST',
        params: data
    });
}

const businessApiService = {
    login,
    register,
    update,
    current,
    publicProfile,
    updateSM,
    postAd,
    updateAd,
    deleteAd,
    getTeam,
    deleteMember,
    updateMember,
    addMember,
    notifications,
    forgot,
    reset,
    profile,
    createSubscription,
    createMembershipSubscription,
    registerSubscription,
    cancelSubscription,
    updateLocale,
    enableFreeTrial,
    sendSupportMessage,
    verify,
    deleteRank,
    createRank,
    updateRank,
    assign_rank_to_student,
    unassign_rank_from_student,
    assignRewardToStudent,
    unassignRewardFromStudent,
    sendMessage,
    sendMessageToAll,
    sendAppInviteMessage,
    create_invoice,
    update_invoice,
    updateWelcomeEmailPrefs,
    updateExpTicketEmailPrefs,
    checkCouponCode,
    connectStripe,
    disconnectStripe,
    sendVerificationEmail,
    updateAddress,
    updateReqFields,
    createPaymentSession,
    getBusinesses,
    weekEvents,
    rewards,
    updateReward,
    createReward,
    deleteReward,
    createPaymentIntent,
    getMessageSettings,
    saveBdSettings,
    saveClassReminderSettings,
    updateWelcomeCustomText,
    saveClassRegistrationSettings,
    setMaster,
    businessMessages,
    studentMessages,
    sendStudentMessage,
};


export default businessApiService;